import React, { useState } from "react";
import unitedsate1 from "../../../assets/images/unitedsate1.png";
import unitedstate2 from "../../../assets/images/unitedstate2.png";
import climateAgents1 from "../../../assets/images/climate-agents-2025-1.png";
import climateAgents2 from "../../../assets/images/climate-agents-2025-2.png";
import climateAgents3 from "../../../assets/images/climate-agents-2025-3.png";
import climateAgents4 from "../../../assets/images/climate-agents-2025-4.png";
import climateAgents5 from "../../../assets/images/climate-agents-2025-5.png";
import climateAgents6 from "../../../assets/images/climate-agents-2025-6.png";
import climateAgents7 from "../../../assets/images/climate-agents-2025-7.png";
import climateAgents8 from "../../../assets/images/climate-agents-2025-8.png";
import climateAgents9 from "../../../assets/images/climate-agents-2025-9.png";
import climateAgents10 from "../../../assets/images/climate-agents-2025-10.png";
import hhSummer1 from "../../../assets/images/hh-summer-2025-1.png";
import hhSummer2 from "../../../assets/images/hh-summer-2025-2.png";
import up1 from "../../../assets/images/up1.png";
import up2 from "../../../assets/images/up2.png";
import up3 from "../../../assets/images/up3.png";
import up4 from "../../../assets/images/up4.png";
import up5 from "../../../assets/images/up5.png";
import up6 from "../../../assets/images/up6.png";
import up7 from "../../../assets/images/up7.png";
import up8 from "../../../assets/images/up8.png";
import up9 from "../../../assets/images/up9.png";
import up10 from "../../../assets/images/up10.png";
import up11 from "../../../assets/images/up11.png";
import up12 from "../../../assets/images/up12.png";
import up13 from "../../../assets/images/up13.png";
import up14 from "../../../assets/images/up14.png";
import up15 from "../../../assets/images/up15.png";
import up16 from "../../../assets/images/up16.png";
import up17 from "../../../assets/images/up17.png";
import up18 from "../../../assets/images/up18.png";
import up19 from "../../../assets/images/up19.png";
import ccaData from "../../../assets/images/CCA 2026 - Comparing data collection results.JPG";
import ccaLake from "../../../assets/images/CCA 2026 - Jessica at the lake.JPG";
import ccaLab from "../../../assets/images/CCA 2026 - Lab.jpg";
import cca1 from "../../../assets/images/CCA 1.JPG";
import cca2 from "../../../assets/images/CCA 2.JPG";
import cca3 from "../../../assets/images/CCA 3.JPG";
import cca4 from "../../../assets/images/CCA 4.JPG";
import uplandGreens from "../../../assets/images/Upland 2026 students gathering greens with Miss Jessica.jpg";
import uplandGrandparent from "../../../assets/images/Upland adopted grandparent reading card from students.jpg";
import uplandBridge from "../../../assets/images/Upland conflict bridge.jpg";
import uplandAndres from "../../../assets/images/Upland student journalist - Andres.jpg";
import uplandJournalist from "../../../assets/images/Upland student journalist.jpg";
import uplandGrounds from "../../../assets/images/Upland students on school grounds.jpg";
import uplandHospital from "../../../assets/images/Upland team at hospital.jpg";
import { Row, Col, Container, Modal, ModalBody, Card, CardImg } from "reactstrap";
const Index = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const toggleModal = () => setModalOpen(!modalOpen);

  const openImageModal = (image) => {
    setSelectedImage(image);
    setModalOpen(true);
  };

  const photoEssayData = [
    {
      image: climateAgents1,
      caption:
        "Amelia Regan helped her team record scatterplot data. (Photo by Jessica Rivenes)",
    },
    {
      image: climateAgents2,
      caption:
        "Aleesha Gilbert conducted field observations. (Photo by Jessica Rivenes)",
    },
    {
      image: climateAgents3,
      caption:
        "Eric Jorgensen offered a low-tech method to check for energy-efficient windows, as Jessica Rivenes conducted the demonstration. (Photo by Amelia Regan)",
    },
    {
      image: climateAgents4,
      caption:
        "Chefs planned, purchased and cooked a meal, then tallied the carbon miles their food had traveled. (Photo by Laksmi Greenberg)",
    },
    {
      image: climateAgents5,
      caption:
        "Dr. Jeff Lauder presented his ecology studies on phytoremediation at Providence Mine. (Photo by Taj Daunch-Greenberg)",
    },
    {
      image: climateAgents6,
      caption:
        "Change Agents returned Jeff's favor by clearing out invasive species, to make room for the cadmium and carbon uptake heroes. (Photo by Taj Daunch-Greenberg)",
    },
    {
      image: climateAgents7,
      caption:
        "Jessica and Taj demonstrated a method for consensus building between mine activists and renewable energy advocates. (Photo by Logan House)",
    },
    {
      image: climateAgents8,
      caption:
        "Audubon officials Rudy Darling and Don Rivenes (left) led the discussion of owls and birds as canaries in the coalmine. (Photo by Aleesha Gilbert)",
    },
    {
      image: climateAgents9,
      caption:
        "Artist Rene Sprattling offered input on artwork that harvests earth's rare beauty rather than its rare earth minable minerals. (Photo by Lily Ning)",
    },
    {
      image: climateAgents10,
      caption:
        "Joe Halay, a Hospitality House facilities manager, explained the inner workings of the building's energy systems, as Logan checked the gauges. (Photo by Amelia Regan)",
    },
  ];

  const ccaAtLakeImages = [
    {
      image: ccaData,
      caption:
        "Change Agents compare their data collection results at the lake",
    },
    {
      image: ccaLake,
      caption: "Jessica at the lake",
    },
    {
      image: cca1,
      caption:
        "A Change Agent deploys a data collection device at the reservoir's edge",
    },
    {
      image: cca2,
      caption:
        "Hydrologist Sol Henderson explains how reservoir chemistry leads to methane",
    },
    {
      image: cca3,
      caption: "The group gathers at the reservoir shoreline",
    },
    {
      image: cca4,
      caption: "The Climate Change Agents together at the lake",
    },
  ];

  const ccaLabImages = [
    {
      image: ccaLab,
      caption: "Change Agents observe the testing of the samples in the lab",
    },
  ];

  const uplandImages = [
    {
      image: uplandGrandparent,
      caption:
        "An adopted grandparent reads a card from the students at Brookdale",
    },
    {
      image: uplandGreens,
      caption: "Students gather greens with Miss Jessica for the food bank",
    },
    {
      image: uplandAndres,
      caption: "Student journalist Andres with his Heroes News reporter badge",
    },
    {
      image: uplandJournalist,
      caption: "A young Heroes News reporter shows her press badge",
    },
    {
      image: uplandBridge,
      caption: "Students march across the conflict bridge to resolve a dispute",
    },
    {
      image: uplandHospital,
      caption:
        "The team delivers handmade cards and gifts at San Antonio Regional Hospital",
    },
    {
      image: uplandGrounds,
      caption: "Young Humanitarians on the school grounds",
    },
  ];

  const renderFigures = (items) => (
    <div className="muli-colmn-tw my-3">
      {items.map((item) => (
        <Card
          className="image-card"
          key={item.caption}
          onClick={() => openImageModal(item)}
          style={{ padding: "6px 0px", cursor: "pointer" }}
        >
          <CardImg
            src={item.image}
            loading="lazy"
            alt={item.caption}
            style={{ height: "400px", objectFit: "cover" }}
          />
        </Card>
      ))}
    </div>
  );

  return (
    <Container>
      <Row>
        <Col
          sm="12"
          md={{
            offset: 1,
            size: 10,
          }}
        >
          <h1 className="mt-4 mb-4 fs-1">United States</h1>
        </Col>
        <Col
          sm="12"
          md={{
            offset: 1,
            size: 10,
          }}
        >
          <div className="rich-text-u mx-auto">
            <h2>Climate Change Agents Make Lifelong Commitment</h2>
            <p>
              The Climate Change Agents completed their reunion project on July
              21, 2026, in Nevada County, California, headquartered at their
              beloved Papa Bear Lodge, the center of their summer camp
              initiatives since the first camp in 2014.
            </p>
            <p>
              Each year&rsquo;s themes culminated in this year&rsquo;s
              celebration of their role as &ldquo;Climate Change Agents for
              Life.&rdquo; Pondering their long-term commitment to improving
              life for all created beings, they discussed the growth of
              seedlings into pinecones and, ultimately, into mature trees. This
              metaphor mirrored the impact of community-service initiatives
              based on their annual habit-of-heart themes, which have not only
              spurred their own growth, inspired their collaborations, and
              shaped their perspectives, but have also generated positive
              impacts for humankind and for other species.
            </p>
            <p>
              Each year, the Climate Change Agents have tackled a specific
              habit-of-heart and climate-related environmental research and
              advocacy challenge. In 2026, they considered an often-overlooked
              question: What diminishes a reservoir&rsquo;s predominant value as
              a carbon sink and water storage container? (A reservoir can
              interrupt ecosystems, displace human communities, and emit an
              abundance of greenhouse gas (especially methane), mostly through
              the algae blooms that occur in stagnant water.)
            </p>
            <p>
              In three teams, the group used several methods to collect visual
              data on the presence of methane in a local reservoir. They also
              reviewed the equipment often used to check water quality, to
              identify their most appropriate data collection tools. A
              hydrologist from Sierra Streams Institute, Sol Henderson, then
              arrived as a guest. He distributed three different data collection
              devices used to further check for high levels of nitrate and
              phosphate, which contribute to the excessive growth of algae and
              other organic material in an aquatic ecosystem.
            </p>
            <p>
              The group went on to the lab to observe the testing of the
              samples. Next, they made explanatory videos for NASA, encouraging
              a lead researcher to continue using satellites to watch for algae
              plumes and to advocate for global attention to methane emissions
              in community reservoirs.
            </p>
            <p>
              The Change Agents also reminisced about their most meaningful
              initiatives over the past 12 years. They sent their thoughts to
              Yale Climate Connections, to thank the outgoing co-founder for
              publicizing their past efforts and also to congratulate the
              university program for prioritizing service to the planet.
            </p>
            <p>
              By the end of the experience, the group also completed their
              annual shopping and cooking challenge, with each team selecting
              its menu items based on criteria such as biodegradable packaging,
              low transportation miles, and limited water use. They celebrated
              the habits-of-heart exhibited by their peers by passing around
              their journals. Each team member praised the qualities they
              appreciated in each of the others.
            </p>
            <p>
              The Change Agents vowed to keep their friendship and collaboration
              strong as they parted to pursue their separate journeys, with some
              completing high school or college and others launching
              service-oriented careers focused on positive change. May they
              always remember their commitment to act on behalf of living
              beings.
            </p>
            <h3>At the Lake</h3>
            {renderFigures(ccaAtLakeImages)}
            <h3>Lab</h3>
            {renderFigures(ccaLabImages)}
            <p>
              <em>
                Project participants included alumni Finn, Erik, Asa, Logan, Taj
                and Jessie, teaming up with Teresa, Lily, Jonah, Sol, Helen, and
                Jax to complete the project.
              </em>
            </p>
            <h2>Upland Summer School 2026 Bred Young Humanitarians</h2>
            <p>
              Experience shapes identity, evidenced by the progress of the
              fourth and fifth graders who practiced the &ldquo;Habits of
              Humanitarians&rdquo; during the 2026 Habits of Heroes Summer
              School in Upland, California. Parents enjoyed witnessing the
              growth of their children. Relevant projects helped the students
              integrate the development of character, curiosity, cognition,
              creativity, and compassion, to address the needs of their human
              family. Each week, they also offered their mentors or constituents
              gifts of music, art, writing or math, and habit-of-heart
              certificates. This summer&rsquo;s initiatives linked local needs
              to five habit-of-heart themes:
            </p>
            <p>
              <strong>Humanitarianism:</strong> During the first week&rsquo;s
              culminating project, the young Humanitarians honored their adopted
              grandparents at Brookdale Assisted Living for their lifelong
              contributions to society. They sang &ldquo;True Heroes,&rdquo;
              offered gifts, and interviewed each elder.
            </p>
            <p>
              <strong>Farsightedness:</strong> The children evaluated the value
              of planning ahead to ensure food security for the hungry. They
              toured the nonprofit Root 66, where they collected farm produce,
              adding it to food boxes they prepared for the local food bank,
              Inland Valley Hope Partners. They prepared the boxes to each feed
              a family of four and recorded the servings or measurements
              accordingly on the boxes.
            </p>
            <p>
              <strong>Universal Connectedness:</strong> A wisdom exchange
              between the students and a summer school in The Gambia compared
              ways to feed a population. (Asmi Aggarwal went as a foreign
              exchange student from the US; among other projects, FCL Gambia
              dried and packaged moringa tea to enhance nutrition, while the
              Upland students told of their project for the food bank.) The
              Upland students wrote letters about universal connectedness to
              their &ldquo;brothers and sisters&rdquo; at FCL Gambia. They also
              made school kits for distant refugee children, to be distributed
              during a visit from the nonprofit JustServe. The children honored
              their guest for creating these connections, by singing the song
              &ldquo;Harmony.&rdquo;
            </p>
            <p>
              <strong>Understanding:</strong> The Upland students studied
              &ldquo;A Day in the Life of a Journalist,&rdquo; presented by the
              staff of Inland Valley News. Prior to the visit, each child had
              conducted interviews at the school in order to submit their own
              articles to the news organization based on their food-related
              research. They sang &ldquo;Questions&rdquo; for their guests and
              distributed in-boxes they had made, to collect news tips. Some
              students professed a commitment to pursue careers generating
              community understanding as journalists.
            </p>
            <p>
              <strong>Seeking:</strong> The young humanitarians considered the
              significance of asking questions to cure disease. They wrote to
              the National Institute of Health to submit new questions about
              cancer. They created watercolors of healthy cells to hang in the
              visiting room of an oncology unit. They also decorated pillowcases
              for patients, delivering their gifts to San Antonio Regional
              Hospital. They sang &ldquo;I Aspire&rdquo; for the staff.
            </p>
            <p>
              At the end of the summer, the students prepared a &ldquo;Noble
              Exhibit&rdquo; based on the humanitarian categories of the Nobel
              prizes. They presented their learning at a mastery ceremony,
              celebrating the habits of heart they appreciated in their parents
              and also receiving certificates of mastery for their own most
              refined habit-of-heart.
            </p>
            <p>
              The successful six-week program resulted from the combined
              commitment of the sponsoring nonprofit, People for Peace and
              Prosperity (PFPP), along with the Special Services Department of
              the Upland Unified School District and the Global Advisory Board
              of Full-Circle Learning. The children especially benefited from
              the mentorship of the staff members, Antoinette Wright, Sierra
              Pohjola, and Soleil Stevenson. Thanks to everyone who contributed!
            </p>
            <h3>Upland Summer 2026 Highlights</h3>
            {renderFigures(uplandImages)}
            <h2>Mining for Gems at Climate Change Agents Camp 2025</h2>
            <p>
              What practices and principles help bridge the path from advocacy
              to action? A cadre of Climate Change Agents, ages 16 – 21,
              gathered in the Sierra foothills this July to explore the
              question. Merit-based scholarships were awarded to the
              participants, listed alphabetically: Taj Daunch-Greenberg, Aleesha
              Gilbert, Logan House, Amelia Regan, and Jessica Rivenes. Set in
              the hills above an abandoned hydraulic mine site, their lodge
              presented an ideal backdrop for researching the centuries-long
              impacts of mining not only on habitats and on health but
              potentially on the acceleration of climate change itself.
            </p>
            <h3>Tracing Impact</h3>
            <p>
              The youth first studied the principles of "moral ambition"
              outlined in Rutger Bregman's latest book, and each defined their
              own potential pathways for improving life among all sentient
              beings.
            </p>
            <p>
              The data collection then began, as they mapped out tree dimensions
              and quantities to compare the features of the abandoned mine site,
              a nearby wildland-urban interface, and a managed forest. On each
              200-foot plot, the young researchers counted the number of trees
              and identified the number and location of older-growth trees (60
              inches or greater in diameter). They observed that the soil in the
              heart of hydraulic mining no longer supported indigenous trees but
              mostly low-growing manzanita shrubs, which had spread like ground
              cover. As a result, the reduction in shade had actually increased
              the air temperature of this study plot.
            </p>
            <p>
              At the second site, a network of conifers thrived, fed by a stream
              and connected by their underground root system in the
              wildland-urban interface. The developers had carefully protected
              the largest of the old-growth trees intact. Still, wildlife
              habitats were interrupted by the prevalence of development and
              human interventions.
            </p>
            <p>
              The third location, a managed forest, offered the greatest
              biodiversity. It featured thriving deciduous trees—maple, alder,
              and dogwood—in a riparian ravine moistened by Deer Creek. The
              portion of the trail once crowded with second-growth plantation
              trees had been thinned to discourage wildfire, while leaving
              old-growth trees intact to serve as the mother trees of the
              ecosystem.
            </p>
            <p>
              In their follow-up discussions, the youth began to see science as
              a series of puzzles and questions, for which potentially more than
              one right answer exists. This idea later became relevant when
              Audubon Society representatives presented information on the
              various impacts of climate change and mining on bird habitats. As
              canaries in the coalmine, changing bird populations reflect
              impacts such as habitat destruction, shifts in migration and
              breeding grounds, response to pollution, and more. Discussions
              reverted to tips for helping birds in an ever-changing climate.
            </p>
            <p>
              As if to emphasize the point, this year's nighttime owling
              experience proved challenging. The new location lacked the
              abundant food sources encountered in previous years down valley.
              Finally, the group moved to a hilltop elevation and eventually
              heard a distant screech owl, but the owl did not approach the
              camp, breaking a years-long pattern of sightings in healthy mixed
              conifer forests.
            </p>
            <h3>Addressing the Needs of the Vulnerable</h3>
            <p>
              While wildlife attracts advocacy work, so do vulnerable human
              populations. Eager not only for research but for service, the
              students visited the energy-efficient home designed by Eric
              Jorgensen to expand their understanding of ways to reduce carbon
              emission. Next, they conducted an energy audit at Utah's Place,
              one of the homeless facilities operated by Hospitality House. The
              managers, along with Eric, led them through various parts of the
              facility, explaining which energy improvements had been conducted
              and what needs remained. The group identified four recommendations
              that would reduce energy costs and emissions and increase the
              comfort level of the guests. The Climate Change Agents then sent
              the Hospitality House board of directors a letter encouraging them
              to support these recommendations. They also advocated that the
              insights of the staff result in allocation of additional resources
              toward energy efficiency.
            </p>
            <h3>Can We Have It Both Ways?</h3>
            <p>
              Nuanced impacts and actions had come into play by now. A primary
              focus of the camp, scientific paradox, led the youth to also
              practice the unifying conflict resolution skills that unify the
              goals of diverse environmental activists. For example, innovative
              manufacturing industries in the global south mine the rare earth
              metals needed to meet the consumer demand for renewable energy.
              However, in so doing, the factories have created counterintuitive,
              negative impacts on climate change mitigation through the mining
              of lithium, cobalt, and other rare earth minerals. Ironically, the
              production of renewables threatens to generate toxic tailings,
              human rights challenges in the developing world, and the release
              of dangerous pollutants into water, air, and soil.
            </p>
            <p>
              Considering the centuries-long impact of mining, the Climate
              Change Agents practiced a conflict resolution exercise between
              anti-mining activists and pro-renewable activists living in a
              hypothetical city considering approval of a new EV car factory.
              Each opposing group offered solutions beneficial to all, such as
              support for further research and development into improved mining
              practices as well as the production of renewable resources that
              don't rely on mining.
            </p>
            <h3>Nature Itself as a Solution Giver</h3>
            <p>
              These background projects prepared the youth for their final
              expedition to a local abandoned hard-rock mine site. They studied
              Dr. Jeff Lauder's research on phytoremediation—use of
              photosynthesis, as opposed to heavy, gas-powered equipment, to
              remediate the unhealthy toxins left by mining. In this research
              study, purple needlegrass, red fescue, and sunflowers proved
              effective in cadmium uptake and also served as assets to the
              carbon sink. Dr. Lauder offered historical perspective and
              ecological insights, and the Climate Change Agents returned the
              favor by removing invasive species at the mine site, to make more
              room for the carbon-and-metal-storage plant heroes. The project
              highlighted the value of innovations that apply natural processes
              to amend the impact of human interventions.
            </p>
            <p>
              The youth also engaged in the act of "mining for beauty" in their
              surroundings. They turned observations of selected natural wonders
              into art gifts. As a final act of service, each one presented an
              aspect of their collective research at a gathering, to introduce
              adults to new insights and pathways of advocacy and action.
            </p>
            <p>
              During the camp, the team engaged in late-nights collaboration
              games and introspection on their potential actions in years to
              come. They demonstrated their capacity to make a difference not
              just by protesting against but, rather, advocating for the changes
              that will generate the greatest good. As perhaps their strongest
              new asset, they deepened their bond with peers who have accepted a
              role as change agents of the present and future.
            </p>
            <p>
              Acknowledgements go to the organizations, donors, and volunteers
              who supported the Climate Change Agents camp. Full-Circle Learning
              offered curriculum support and supplemental funding. Nevada County
              Climate Action Now, Sierra Streams, Hospitality House, and Sierra
              Foothills Audubon Society provided mentors. The latter (SFAS) also
              provided major donations and fiscal agent support. It took a
              village to raise the awareness of these young advocates and turn
              knowledge into action.
            </p>
            <h3>Climate Change Agents 2025 Photo Essay</h3>
            <ol className="ps-3 ps-md-4">
              {photoEssayData.map((item, index) => (
                <li key={index} className="mb-2">
                  <button
                    onClick={() => openImageModal(item)}
                    style={{
                      cursor: "pointer",
                      color: "#007bff",
                      textDecoration: "underline",
                      wordBreak: "break-word",
                      display: "inline",
                      lineHeight: "1.5",
                      background: "none",
                      border: "none",
                      padding: "0",
                      font: "inherit",
                      textAlign: "left",
                    }}
                  >
                    {item.caption}
                  </button>
                </li>
              ))}
            </ol>
            {photoEssayData.map((item, index) => (
              <figure key={index} className="mx-auto mt-4 mb-4 text-center">
                <div className="d-flex justify-content-center">
                  <img
                    src={item.image}
                    loading="lazy"
                    alt={item.caption}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      width: "auto",
                      maxHeight: "600px",
                    }}
                    className="img-fluid"
                  />
                </div>
                <figcaption
                  className="text-center mt-2 px-2"
                  style={{ fontSize: "0.9rem", lineHeight: "1.4" }}
                >
                  {item.caption}
                </figcaption>
              </figure>
            ))}
            <h2>Habits of Heroes Newsletter - Summer 2025</h2>
            <Row className="mb-4">
              <Col md={8} className="order-2 order-md-1">
                <p>
                  Young heroes in Upland, California expanded their vision,
                  rolled up their sleeves, and opened their hearts this summer,
                  through a special program to support the local Compassionate
                  Communities movement.
                </p>
                <p>
                  Upper elementary and incoming middle school students attended
                  academically focused bridge classes in the morning. In the
                  afternoon, a pilot group enrolled in the half-day Habits of
                  Heroes program at Cabrillo Elementary School. The program
                  resulted from a collaboration between&nbsp;
                  <a href="https://www.peopleforpeaceandprosperity.org/">
                    People for Peace and Prosperity
                  </a>
                  , Full-Circle Learning, and the Upland Unified School
                  District's Special Services Department, led by Mario Jacquez.
                </p>
              </Col>
              <Col md={4} className="order-1 order-md-2 mb-3 mb-md-0">
                <img
                  src={hhSummer1}
                  alt="Habits of Heroes Summer 2025"
                  className="img-fluid w-100"
                  style={{ maxHeight: "400px", objectFit: "cover" }}
                />
              </Col>
            </Row>
            <Row className="mb-4">
              <Col md={8} className="order-2 order-md-1">
                <p>
                  Over the summer, participants completed four learning units:
                  Vision Seeking, Selflessness, Advocacy, and Dedication. Within
                  each unit, they learned academic concepts and life skills
                  related to the theme. They also honored community role models
                  and participated in relevant service-learning field trips as
                  they strived to master each successive habit-of-heart.
                </p>
              </Col>
              <Col md={4} className="order-1 order-md-2 mb-3 mb-md-0">
                <img
                  src={hhSummer2}
                  alt="Habits of Heroes Activities"
                  className="img-fluid w-100"
                  style={{ maxHeight: "400px", objectFit: "cover" }}
                />
              </Col>
            </Row>

            <h3>Vision Seeking</h3>
            <Row className="mb-4">
              <Col md={3} className="mb-3 mb-md-0">
                <img
                  src={up1}
                  alt="Vision Seeking at Brookdale"
                  className="img-fluid w-100"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
              <Col md={6}>
                <p>
                  On a visit to Brookdale Assisted Living, each child
                  interviewed an elder and honored them for their contributions
                  to society, with handmade gifts and artwork.
                </p>
                <p>
                  The class also exchanged wisdom with a school in Nigeria, to
                  learn from peers about how to develop a vision such as
                  reducing health disparities in a community.
                </p>
              </Col>
              <Col md={3} className="mb-3 mb-md-0">
                <img
                  src={up2}
                  alt="Wisdom exchange with Nigeria"
                  className="img-fluid w-100"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
            </Row>

            <h3>Selflessness</h3>
            <Row className="mb-4">
              <Col md={8} className="order-2 order-md-1">
                <p>
                  California Botanic Garden docents emphasized ways to speak out
                  for voiceless species. Here, the Heroes gathered around lead
                  teacher Antoinette Wright to explore the garden. Afterward,
                  the class honored docents with a paper flower bouquet.
                </p>
              </Col>
              <Col md={4} className="order-1 order-md-2 mb-3 mb-md-0">
                <img
                  src={up3}
                  alt="California Botanic Garden"
                  className="img-fluid w-100"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
            </Row>
            <Row className="mb-4">
              <Col md={6}>
                <img
                  src={up4}
                  alt="Dr. Nicole Weinstein presentation"
                  className="img-fluid w-100 mb-3"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
              <Col md={6}>
                <p>
                  While practicing the habit of selflessness, students also
                  learned about career choices that prioritize the needs of
                  others, They welcomed classroom presentations by veterinarian
                  Dr. Nicole Weinstein (and her kitten assistant) and by a
                  Hospice Chaplain, Reverend Kathleen Reeves.
                </p>
                <img
                  src={up5}
                  alt="Reverend Kathleen Reeves presentation"
                  className="img-fluid w-100 mt-3"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
            </Row>

            <h3>Advocacy</h3>
            <Row className="mb-4">
              <Col md={4} className="mb-3 mb-md-0">
                <img
                  src={up6}
                  alt="Rancho Cucamonga Superior Court"
                  className="img-fluid w-100"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
              <Col md={8}>
                <p>
                  Rancho Cucamonga Superior Court served as the backdrop for
                  understanding how judges, juries, and attorneys strive to
                  create justice and advocate for the rights of both plaintiffs
                  and victims. Students sang to Judge Uhler and toured the
                  facility, offering gifts to thank the staff for their service,
                  after an in-class presentation about dispute resolution by
                  attorney Soheila Azusa (pictured).
                </p>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col>
                <img
                  src={up7}
                  alt="Attorney Soheila Azusa presentation"
                  className="img-fluid w-100"
                  style={{ maxHeight: "400px", objectFit: "cover" }}
                />
              </Col>
            </Row>

            <h3>Dedication</h3>
            <Row className="mb-4">
              <Col md={8} className="order-2 order-md-1">
                <p>
                  The habit-of-heart dedication, an essential tool for
                  architects, inspired a study of Andrew Carnegie. In the early
                  twentieth century, Carnegie ensured that almost every major
                  city, including Upland, would acquire a distinctive, free
                  public library. Engineer Mehrdad Nosrat taught the Heroes how
                  to create a blueprint for such a facility.
                </p>
              </Col>
              <Col md={4} className="order-1 order-md-2 mb-3 mb-md-0">
                <img
                  src={up8}
                  alt="Engineer Mehrdad Nosrat"
                  className="img-fluid w-100"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
            </Row>
            <Row className="mb-4">
              <Col md={6}>
                <p>
                  On a trip to the public library, the learners researched
                  designs to inspire their own architectural models.
                </p>
              </Col>
              <Col md={6}>
                <img
                  src={up9}
                  alt="Public library visit"
                  className="img-fluid w-100"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
            </Row>

            <h3>In-Class Highlights</h3>
            <Row className="mb-4">
              <Col>
                <p>
                  Academic projects infusing art, music, role plays,
                  discussions, and guided imagery (mindfulness) activities
                  prepared students for their community work.
                </p>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={3} className="mb-3 mb-md-0">
                <img
                  src={up10}
                  alt="Guided imagery exercise"
                  className="img-fluid w-100"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
              <Col md={6}>
                <p>
                  Antoinette Wright led guided imagery exercises based on the
                  book, The Sky Belongs to Everyone. The Heroes took journeys of
                  the mind to reinforce their heroic identities.
                </p>
              </Col>
              <Col md={3} className="mb-3 mb-md-0">
                <div style={{ overflow: "hidden" }}>
                  <img
                    src={up12}
                    alt="Habit-of-heart basketball"
                    className="img-fluid w-100"
                    style={{
                      maxHeight: "300px",
                      objectFit: "cover",
                      transform: "rotate(-90deg)",
                      display: "block",
                    }}
                  />
                </div>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={8} className="order-2 order-md-1">
                <p>
                  Intern Savannah Lindsey mediated each march across the
                  conflict bridge.
                </p>
                <p>
                  Examples of role plays included a sibling dispute about a
                  borrowed item not returned, as well as a conflict between a
                  bus driver and a rider lacking ample bus fare.
                </p>
              </Col>
              <Col md={4} className="order-1 order-md-2 mb-3 mb-md-0">
                <img
                  src={up11}
                  alt="Conflict bridge activity"
                  className="img-fluid w-100"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={8} className="order-2 order-md-1">
                <p>
                  The Heroes also acted out their unit themes by playing
                  habit-of-heart basketball.
                </p>
              </Col>
              <Col md={4} className="order-1 order-md-2 mb-3 mb-md-0">
                <img
                  src={up13}
                  alt="More basketball activities"
                  className="img-fluid w-100"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={4} className="mb-3 mb-md-0">
                <img
                  src={up14}
                  alt="Art lesson"
                  className="img-fluid w-100"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
              <Col md={8}>
                <p>
                  Intern Sara Dawidian taught a lesson entitled, Art Can Change
                  the World.
                </p>
                <p>
                  The Heroes embraced the concept as they made "Hero" bracelets
                  for community role models, hats to honor elders, and
                  architectural concepts to inspire buildings that benefit
                  society.
                </p>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={6}>
                <img
                  src={up15}
                  alt="Hero bracelets"
                  className="img-fluid w-100 mb-3"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
              <Col md={6}>
                <img
                  src={up16}
                  alt="Art projects"
                  className="img-fluid w-100 mb-3"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={8} className="order-2 order-md-1">
                <p>
                  JustServe volunteers (right) laid the groundwork for the plan
                  to give paper flowers to docents.
                </p>
              </Col>
              <Col md={4} className="order-1 order-md-2 mb-3 mb-md-0">
                <img
                  src={up17}
                  alt="JustServe volunteers"
                  className="img-fluid w-100"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
            </Row>

            <h3>Celebrating Compassion</h3>
            <Row className="mb-4">
              <Col md={4} className="mb-3 mb-md-0">
                <img
                  src={up18}
                  alt="Mastery ceremony"
                  className="img-fluid w-100"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
              <Col md={8}>
                <p>
                  At the final mastery ceremony, each student received a
                  teacher's certificate for the habit they best mastered.
                </p>
                <p>
                  In turn, the children each presented a Hero certificate to
                  parents or to a caregiver for the habit they most appreciated
                  in that family member.
                </p>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={6}>
                <img
                  src={up19}
                  alt="Certificate presentation"
                  className="img-fluid w-100 mb-3"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </Col>
              <Col md={6}>
                <p>
                  Those present filled out anonymous surveys, with 100%
                  reporting that their children had improved beyond their
                  expectations in at least 15 of 19 skill sets, including a
                  heightened motivation to learn. The evening ended with pizza,
                  provided by People for Peace and Prosperity, and
                  congratulations for the evolving young heroes.
                </p>
              </Col>
            </Row>

            <figure className="mx-auto">
              <div>
                <img src={unitedsate1} loading="lazy" alt="my alt" />
              </div>
            </figure>
            <h2>April 2022:&nbsp;Global Harvests that Harmonize Hearts</h2>
            <p>
              “Let them stare. Let them see. We will show the world harmony,”
              sang school children from the Osun State of Nigeria to immigrant
              children in Los Angeles County, in response to a recent
              Full-Circle Learning wisdom exchange.&nbsp;
            </p>
            <p>
              Earlier in the school year, Tarzana Elementary School’s
              Habits-of-Heart students set out to plant seeds of kindness. Their
              teacher helped them integrate academic and arts projects and send
              a wisdom exchange package, including hand-made gifts of tie-dyed
              shirts, to classmates across the ocean. Each child penned a list
              of inquiries to their new brothers and sisters, sharing their own
              upcoming plans to grow <em>real</em> seeds of kindness in a
              community garden.&nbsp;
            </p>
            <p>
              They sent their package at a time when shipping delays plagued the
              US Postal Service. (For a time, we wondered whether the large box
              would <em>ever </em>get as far as Lagos, let alone to the
              village.) After many calls to the customs office, the Nigerian
              wisdom exchange liaison finally reported its arrival.&nbsp; Her
              delighted students wrote replies about their own farming projects
              and their process of making dye from vegetables. Their Unity Class
              (grades 2-3) had grown local plants as gifts for teachers. Their
              Patience Class (Preschoolers) had grown maize and cassava to feed
              the community. Their first-grade Cooperation Class had honored
              local orphanage founders for kindness.&nbsp;
            </p>
            <p>
              Cherishing the letters and wearing the shirts, the Nigerian
              children sang the Harmony song and videotaped it for their faraway
              family in the town of Tarzana. Meanwhile, Tarzana’s principal
              shared the story with joyous parents, many of them immigrants
              themselves. The Full-Circle Learners enjoyed knowing they could
              sow seeds of kindness abroad and watch them sprout.&nbsp;
            </p>
            <figure className="mx-auto">
              <div>
                <img src={unitedstate2} loading="lazy" alt="my alt" />
              </div>
            </figure>
          </div>
        </Col>

        <Col
          sm="12"
          md={{
            offset: 1,
            size: 10,
          }}
        >
          <div className="rich-text-u">
            <p>
              Full-Circle Learning has provided teacher training or direct
              student-service programs at each of these 43 learning institutions
              in the United States between 1992 and 2020 (photo essay attached):
            </p>
            <p>
              <strong>Arizona</strong>
            </p>
            <ol start="">
              <li>Professional Development, Nurtured Heart School, Tucson</li>
            </ol>
            <p>
              &zwj;<strong>California</strong>{" "}
            </p>
            <p>
              <strong>(40 Programs)</strong>{" "}
            </p>
            <p>
              <strong>Southern California</strong>
            </p>
            <ol start="" className="united_state_li">
              <li>
                <a href="/upland-summer-school-2026-young-humanitarians">
                  Upland Summer School 2026: Bred Young Humanitarians
                </a>{" "}
              </li>
              <li>
                <a href="/alumni-clubs">Alumni Clubs</a>
              </li>
              <li>
                Chapman University Course Materials (Social Justice Education)
              </li>
              <li>
                <a href="/childrens-enrichment-summer-school-and-after-school-programs">
                  Children’s Enrichment Summer School and After-School programs
                </a>{" "}
              </li>
              <li>
                <a href="/huntington-hotel-fcl-school">
                  Huntington Hotel FCL School
                </a>{" "}
              </li>
              <li>
                Encino Elementary After-School Programs; Encino
                ProfessionalDevelopment Training{" "}
              </li>
              <li>Full-Circle Learning Alumni Club </li>
              <li>Cleveland Elementary School, Pasadena </li>
              <li>
                <a href="/full-circle-learning-academy">
                  Full-Circle Learning Academy (inner-city charter school)
                </a>{" "}
              </li>
              <li>King Elementary: FCL-Integrated Science Program </li>
              <li>Oak Park High Full-Circle Learning Club </li>
              <li>
                Phenomenex: Full-Circle Learning and Leadership and LifeSkills
                workshops{" "}
              </li>
              <li>
                <a href="/piru-full-circle-learning-preschool">
                  Piru Full-Circle Learning Preschool
                </a>{" "}
              </li>
              <li>
                <a href="/rancho-sespe-piru-summer-school-and-year-round-enrichment-program">
                  Rancho Sespe/Piru Summer school and year-round enrichment
                  program
                </a>{" "}
              </li>
              <li>SANAD Cultural Preservation School </li>
              <li>Santa Ana School District professional development </li>
              <li>
                <a href="/spurgeon-school-fcl-program">
                  Spurgeon School FCL Program
                </a>{" "}
              </li>
              <li>
                <a href="/tarzana-elementary-schoolwide-professional-development-and-habits-of-heart-club">
                  Tarzana Elementary: School wide Professional Development and
                  Habits-of-Heart Club
                </a>{" "}
              </li>
              <li>Topanga Elementary project </li>
              <li>Topanga Global Professional Development Workshops</li>
            </ol>
            <p>
              <strong>Northern California</strong>
            </p>
            <ol start="" className="united_state_li">
              <li>
                <a href="/climate-change-agents-make-lifelong-commitment">
                  Climate Change Agents Make Lifelong Commitment (2026 Reunion)
                </a>{" "}
              </li>
              <li>
                <a href="/climate-change-agents-camp-nevada-county">
                  Climate Change Agents Camp, Nevada County
                </a>{" "}
              </li>
              <li>
                <a href="/northern-california-community-education-initiative-cei">
                  Community Education Initiative (CEI) Summer School – El
                  Cerritos
                </a>
              </li>
              <li>
                <a href="/diabetes-awareness-camp-co-hosted-by-levitate">
                  Diabetes Awareness Camp (co-hosted)
                </a>
              </li>
            </ol>
            <p>Professional Development Workshops in:</p>
            <ol start="" className="united_state_li">
              <li>
                <a href="/grass-valley-education-as-transformation-statewide-training">
                  Plumas County: Teacher Training, Quincy - multiple schools,
                  hosted by local Plumas Audubon Society
                </a>{" "}
              </li>
              <li>
                Oakland – Kaiser Corp. Building – Leadership and Life
                Skills{" "}
              </li>
              <li>San Leandro – Public Library – Full-Circle Learning </li>
              <li>San Francisco – California Community Foundation Building </li>
              <li>San Rafael – Global Wisdom Exchange Training </li>
              <li>
                Nevada County School District Office – Full-Circle Learning{" "}
              </li>
              <li>
                <a href="/grass-valley-education-as-transformation-statewide-training">
                  Grass Valley (Education as Transformation statewide
                  training){" "}
                </a>{" "}
              </li>
              <li>Professional Development: Wisdom Exchange: Nevada City </li>
              <li>Professional Development: Service-Learning, Nevada City </li>
              <li>Zeum Museum: Joint Project for Global Schools </li>
            </ol>
            <p>
              <strong>Florida</strong>
            </p>
            <ol start="" className="united_state_li">
              <li>
                {" "}
                Gainesville: Regional training workshop
                <br />{" "}
              </li>
              <li>
                {" "}
                <a href="/hidden-oak-reading-program">
                  Hidden Oak reading program
                </a>
                <br />{" "}
              </li>
              <li>
                {" "}
                Prairie View in-school program school
                <br />{" "}
              </li>
              <li>
                {" "}
                Jackson: Venus School professional development
                <br />{" "}
              </li>
              <li>
                {" "}
                Rawlings Elementary professional development/in-school program
              </li>
            </ol>
            <p>
              {" "}
              <strong>New Mexico</strong>{" "}
            </p>
            <ol start="">
              <li>
                {" "}
                Albuquerque Professional Development
                <br />{" "}
              </li>
              <li>
                {" "}
                Anthony New Mexico/Anthony Texas Professional Development{" "}
              </li>
              <li> Professional Development, Ganado </li>
            </ol>
            <p>
              {" "}
              <strong>New Jersey</strong>{" "}
            </p>
            <ol start="">
              <li> Newark School District Professional Development </li>
            </ol>
            <p>
              {" "}
              <strong>New York</strong>{" "}
            </p>
            <ol start="">
              <li> New York City School District Professional Development </li>
              <li> Paul Robeson Middle School </li>
            </ol>
            <p>
              {" "}
              <strong>Rhode Island</strong>{" "}
            </p>
            <ol start="">
              <li> Children’s Theatre Company</li>
            </ol>
          </div>
          <div className="rich-text-u"></div>
        </Col>
      </Row>
      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg" centered>
        <ModalBody className="p-0">
          {selectedImage && (
            <>
              <div
                onClick={toggleModal}
                style={{ cursor: "pointer", position: "relative" }}
              >
                <img
                  src={selectedImage.image}
                  alt={selectedImage.caption}
                  style={{ width: "100%", height: "auto" }}
                  className="img-fluid"
                />
                <button
                  type="button"
                  className="btn-close position-absolute top-0 end-0 m-2 bg-white"
                  aria-label="Close"
                  onClick={toggleModal}
                  style={{ zIndex: 1 }}
                ></button>
              </div>
              <p
                className="mt-3 mb-3 px-3"
                style={{ fontSize: "0.9rem", lineHeight: "1.4" }}
              >
                {selectedImage.caption}
              </p>
            </>
          )}
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default Index;
